import React from "react";

const Index = ({ loader, children, onClick, styles }) => {
  return (
    <>
      <button
        //   disabled={loader === true}
        type="submit"
        className={`${styles}`}
        onClick={(e) => {
          e.preventDefault();
          onClick();
        }}
      >
        {/* {loader && <Loader />} Next */}
        {children}
      </button>
    </>
  );
};

export default Index;
